import { useQuery } from "react-query";
import { Get } from "src/apis/api";
import { JobLevelType, ListResponseType, ResponseType } from "src/types";

export const useJobLevels = () => useQuery<{}, {}, ListResponseType<JobLevelType>>({
    queryFn: () => Get('/basic-information/job-levels'),
    queryKey: ['GetJobLevels'],
    onError: () => {
        console.log('ERROR')
    }
})